import { render, staticRenderFns } from "./RatingQuestion.vue?vue&type=template&id=7394a2e2&scoped=true"
import script from "./RatingQuestion.vue?vue&type=script&lang=js"
export * from "./RatingQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7394a2e2",
  null
  
)

export default component.exports